import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseOrderBranchURL = `api/v1/purchase-app/purchase-order`;

//obtaining the paginated data
export const getPurchaseOrderBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseOrderBranchURL}/list?party_type=branch_supplier&${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseOrderBranch = () =>
  axiosInstance.get(`${purchaseOrderBranchURL}/list?party_type=branch_supplier&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseOrderBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseOrderBranchURL}/list?party_type=branch_supplier&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

// get purchase order additional charge list
export const getPurchaseOrderBranchAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getPurchaseOrderBranchById = (id) => axiosInstance.get(`${purchaseOrderBranchURL}/retrieve/${id}`);

//get sale order detail from sale order master id
export const getSaleOrderDetail = (id) =>
  axiosInstance.get(`api/v1/sales-app/sales-order-detail/list/dropdown?salesOrderMain=${id}`);

//creating function
export const createPurchaseOrderBranch = (body) => axiosInstance.post(`${purchaseOrderBranchURL}/create`, body);
//updating function
export const updatePurchaseOrderBranch = (id, body) => axiosInstance.patch(`${purchaseOrderBranchURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseOrderBranchURL}/list?party_type=branch_supplier&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

export const getPurchaseOrderBranchChargeStatus = (type) =>
  axiosInstance.get(`api/v1/core-app/additional-charge-status/list?transaction_type=${type}&is_active=true`);
